import { memo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import Table from "../../components/Table.js";
import Spinner from "../../components/Spinner.js";
import { BackButton } from "../../components/Buttons.js";
import { getAnimalRegistraitonLogs } from "../../api/index.js";
import { useSnackbar } from "../../utils/index.js";
import useSelectStyles from "../../components/styles/Select";
import dayjs from "dayjs";
import {
    registrationLogTimestampHeader,
    registrationLogUserNameHeader,
    registrationLogUserEmailHeader,
    registrationLogOwnerCodeHeader,
    registrationLogOwnerNameHeader,
    registrationLogAnimalCodeHeader,
} from "../../components/TableHeaders.js";

const RegistrationLogs = () => {
    const [logs, setLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const classes = useSelectStyles();
    const { error } = useSnackbar();
    const navigate = useNavigate();

    useEffect(() => {
        fetchLogs();
    }, []);

    const fetchLogs = async () => {
        setIsLoading(true);
        try {
            const { success, logs: fetchedLogs, message } = await getAnimalRegistraitonLogs();
            if (success) {
                setLogs(fetchedLogs || []);
            } else {
                error(message || "Αποτυχία φόρτωσης ιστορικού");
            }
        } catch (err) {
            error("Σφάλμα κατά τη φόρτωση του ιστορικού");
            console.error(err);
        }
        setIsLoading(false);
    };

    // Format logs data for the table
    const formattedLogs = logs.map((log) => ({
        ...log,
        userName: log.user?.fullName || "Άγνωστος Χρήστης",
        userEmail: log.user?.email || "-",
        ownerName: log.owner
            ? `${log.owner.firstName || ""} ${log.owner.lastName || ""}`.trim() || log.owner.code
            : "-",
        ownerCode: log.owner?.code || "-",
        animalCode: log.animal?.registrationCode || log.animalRegistrationCode || "-",
        timestamp: log.timestamp
            ? dayjs(log.timestamp).format("DD/MM/YYYY HH:mm:ss")
            : dayjs(log.createdAt).format("DD/MM/YYYY HH:mm:ss"),
    }));

    const tableHeaders = [
        registrationLogTimestampHeader,
        registrationLogUserNameHeader,
        registrationLogUserEmailHeader,
        registrationLogOwnerCodeHeader,
        registrationLogOwnerNameHeader,
        registrationLogAnimalCodeHeader,
    ];

    return (
        <>
            <Spinner open={isLoading} />
            <Box className={classes.outerBox}>
                <Box container flexDirection="column" className={classes.innerBox}>
                    <Typography variant="h5" sx={{ margin: "1rem", textAlign: "center" }}>
                        Ιστορικό Αναζητήσεων Γενεαλογικών Πιστοποιητικών
                    </Typography>

                    <Typography variant="body2" sx={{ margin: "1rem", textAlign: "center", color: "text.secondary" }}>
                        Εμφανίζονται όλες οι αναζητήσεις πιστοποιητικών από χρήστες του οργανισμού σας
                    </Typography>

                    {formattedLogs.length > 0 ? (
                        <Table
                            columns={tableHeaders}
                            data={formattedLogs}
                            tableCase="registrationLogs"
                            maxHeight="70vh"
                        />
                    ) : (
                        !isLoading && (
                            <Typography variant="body1" sx={{ margin: "2rem", textAlign: "center" }}>
                                Δεν υπάρχουν αναζητήσεις για προβολή
                            </Typography>
                        )
                    )}

                    <BackButton
                        title="Επιστροφή"
                        onClick={() => navigate("/info/animal/registration")}
                        sx={{ margin: "1rem", backgroundColor: "secondary.main", color: "white !important" }}
                    />
                </Box>
            </Box>
        </>
    );
};

export default memo(RegistrationLogs);
